export interface PhoneCompany {
  name: string;
}

export enum PhoneCompanies {
  Claro = 'Claro',
  Tigo = 'Tigo',
  Vox = 'Vox',
  Personal = 'Personal',
  SinInformacion = 'Sin información',
}
